import { literal, TypeOf, union } from 'io-ts'

export const environmentCodec = union([literal('development'), literal('production'), literal('staging')])

export type Environment = TypeOf<typeof environmentCodec>
